// import dependencies
import React from "react";
import getYouTubeId from "get-youtube-id";
import Youtube from "react-youtube";
import urlBuilder from "@sanity/image-url";

// Serialize content from sanity
const builder = urlBuilder({
    projectId: "9jeir00f", 
    dataset: "production"
});

const urlFor = (source) => {
    return builder.image(source);
}

const serializers = {
    types: {
        block(props) {
            switch (props.node.style) {
                case "h1":
                    return <h1>{props.children}</h1>;
                case "h2":
                    return <h2>{props.children}</h2>;
                case "h3":
                    return <h3>{props.children}</h3>;
                case "h4":
                    return <h4>{props.children}</h4>;
                case "blockquote":
                    return <blockquote>{props.children}</blockquote>;
                case "normal":
                    return <p>{props.children}</p>;
                default:
                    return <p>{props.children}</p>;
            }
        },
        figure: (props) => (
            <figure>
                <img src={urlFor(props.node.asset)} alt={props.node.alt}/>
            </figure>
        ),
        youtube: ({node}) => {
            const { url } = node
            const id = getYouTubeId(url)
            return (<Youtube className="video" videoId={id} />)
        },
        manuscript: (props) => (
            <pre data-language={props.node.language}>
                <code>{props.node.code}</code>
            </pre>
        )
    },
    marks: {
        strong: (props) => (
            <strong>{props.children}</strong>
        ),
        em: (props) => (
            <em>{props.children}</em>
        ),
        link: (props) => {
            return (<a href={props.mark.href}>{props.children}</a>);
        }
    }
}
export default serializers;